var React = require('react');

function PlayBtn (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#FFF","key":0}),React.createElement("path",{"fill":"#006AFF","fillRule":"nonzero","d":"M26.27 18.506l9.918 8.363c.75.631.75 1.633 0 2.264l-9.91 8.357c-.494.426-1.231.603-1.93.463-.698-.14-1.25-.575-1.446-1.139-.195-.564-.236-17.213.082-17.823.318-.61 1.058-1.002 1.871-.99.54.006 1.055.192 1.415.505z","key":1})]));
}

PlayBtn.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56"};

module.exports = PlayBtn;

PlayBtn.default = PlayBtn;
